import toast from "react-hot-toast";
import { TFunction } from "i18next";

export const renderErrorMessages = (errors: string[], t?: TFunction) => {
    if (!errors || errors.length === 0) {
        return;
    }

    errors.forEach((error, index) => {
        setTimeout(() => {
            toast.error(t ? t(error) : error, {
                duration: 4000,
                position: "top-center",
            });
        }, index * 100);
    });
};
